import { useBoolean } from "@newHooks/common/useBoolean";

export function useArchiverDialogs() {
  return {
    openCreateFolderDialog: useBoolean(false),
    openCreateDocumentDialog: useBoolean(false),
    openAuditTrailDialog: useBoolean(false),
    openRenameResourceDialog: useBoolean(false),
    openRemoveFolderDialog: useBoolean(false),
    openRemoveFileDialog: useBoolean(false),
    openSharingDialog: useBoolean(false),
    openMoveResourceDialog: useBoolean(false),
  };
}
